import { ReactNode, memo } from 'react';
import classnames from 'classnames';
import styles from './InfoSection.module.scss';

type Props = {
  border?: boolean;
  children?: ReactNode;
  swatches?: boolean;
  otherClasses?: string;
  className?: string;
};

const InfoSection = ({
  children,
  otherClasses,
  swatches = false,
  border = true,
  ...props
}: Props) => (
  <div
    className={classnames(styles.infoSection, otherClasses, {
      [styles.swatches]: swatches,
      [styles.border]: border,
    })}
    {...props}
  >
    {children}
  </div>
);

export default memo(InfoSection);
